<script>
export default {
  name: "geolacationIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 13.3108C13.5795 13.3108 14.86 12.0304 14.86 10.4508C14.86 8.8713 13.5795 7.59084 12 7.59084C10.4205 7.59084 9.14001 8.8713 9.14001 10.4508C9.14001 12.0304 10.4205 13.3108 12 13.3108Z"
      stroke="#7A889B"
      stroke-width="1.5"
    />
    <path
      d="M4.31835 8.7825C6.12418 0.844164 17.885 0.853331 19.6817 8.79166C20.7359 13.4483 17.8392 17.39 15.3 19.8283C13.4575 21.6067 10.5425 21.6067 8.69085 19.8283C6.16085 17.39 3.26418 13.4392 4.31835 8.7825Z"
      stroke="#7A889B"
      stroke-width="1.5"
    />
  </svg>
</template>

<style scoped></style>
